import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Pop = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C8.28038 2 2 8.28038 2 16C2 23.7196 8.28038 30 16 30C23.7196 30 30 23.7196 30 16C30 8.28038 23.7196 2 16 2ZM25.1586 23.7442L22.3159 20.9015C23.1765 19.7951 23.7525 18.4583 23.9354 17H27.9581C27.7459 19.5586 26.7277 21.8915 25.1586 23.7442ZM16 22C12.6915 22 10 19.3085 10 16C10 12.6915 12.6915 10 16 10C19.3085 10 22 12.6915 22 16C22 19.3085 19.3085 22 16 22ZM17 23.9352C18.4583 23.7525 19.7951 23.1764 20.9015 22.3158L23.7442 25.1585C21.8915 26.7276 19.5585 27.7457 17 27.9579V23.9352ZM4 16C4 9.38312 9.38312 4 16 4C22.28 4 27.4481 8.84937 27.958 15H23.9352C23.4414 11.0594 20.0724 8 16 8C11.5887 8 8 11.5887 8 16C8 20.0724 11.0594 23.4414 15 23.9352V27.958C8.84937 27.4481 4 22.28 4 16Z" />
	</svg>
);

export default Pop;
